import Loadable from 'react-loadable'
import LoadingIndicatorFull from './LoadingIndicatorFull.js'

const LoadableMarkdownEditor = Loadable({
  loader: () => import('./MarkdownEditor.js'),
  loading: LoadingIndicatorFull,
})

export default LoadableMarkdownEditor
